<template>
    <div class="container mx-auto p-4">
      <div class="flex">
        <!-- <CategoryList class="w-1/4 mr-4" /> -->
        <ProductList class="w-full" :products="products" :auth="auth" />
      </div>
    </div>
  </template>
  
  <script>
  import ProductList from './components/ProductList.vue';
  import CategoryList from './components/CategoryList.vue';
import WebLayout from '../../Layouts/WebLayout.vue';
  
  export default {
    layout: WebLayout,
    props: {
      products: Object,
      auth: Object
    },
    components: {
      ProductList,
      CategoryList
    }
  };
  </script>